import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivityService } from '../../core/services/activity.service';
import { Activity } from '../../core/models/activity.model';
import { Observable, Subscription } from 'rxjs';
import { map  } from 'rxjs/operators';

import { OfferInfoModalComponent } from '../../shared/offer-info-modal/offer-info-modal.component';
import { TranslateService } from '@ngx-translate/core';


import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

@Component({
  selector: 'app-experience',
  templateUrl: './experience.page.html',
  styleUrls: ['./experience.page.scss'],
})
export class ExperiencePage implements OnInit {


  activity$: Observable<Activity>;

   nowStr: string;

  constructor( 
    private route: ActivatedRoute,
    private router: Router,
    private modalCtrl: ModalController,
    public activityService: ActivityService,
    public translateService: TranslateService

  ) { 

     this.nowStr = moment().format();
  }

  ngOnInit() {
    this.activity$ = this.activityService.getActivityBySlug( this.route.snapshot.params.activitySlug );
  }

  openOfferInfoModal(event) {

    this.modalCtrl.create({
      component: OfferInfoModalComponent,
      cssClass: 'my-modal',
      componentProps: { 'event': event }
    })
    .then( modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    })
    .then( resultData => {

      /*if ( 'picked' === resultData.role && undefined !== resultData.data  ) {
        //redirect to shop
        this.router.navigate( [ '/restavracija', resultData.data.providerId, resultData.data.slug ] );
      }*/

    });
  }

}
